import Backbone from 'backbone';
import BackboneDeepModel from '@kahwee/backbone-deep-model';
import Utils from '../utils';
import {
  getParameterByName
} from './../../../base/utils.js';
import Errors from './../../base/errors.js';
import {
  removeNonNumeric
} from './../../base/phone.js';
import Form from './../../base/form.js';
import {
  requestUrls, ENROLL_PHONE_COUNTRY
} from './../../../base/vars.js';

export default BackboneDeepModel.extend({
  url: requestUrls['getProfile'],

  initialize() {
    this.setPromoCode();
    this.on('error', (model, xhr, options) => {
      this.error(model, xhr, options);
    });
  },

  defaults: {
    Customer: {
      PersonName: {
        GivenName: '',
        Surname: ''
      },
      Emails: [{
        EmailType: 1,
        DefaultInd: true,
        Email: ''
      }],
      Addresses: [{
        Type: 1,
        DefaultInd: true,
        CountryCode: '',
        PostalCode: ''
      }],
      Telephones: [{
        DefaultInd: true,
        PhoneTechType: 1,
        PhoneNumber: '',
        PhoneLocationType: ''
      }],
      BusinessTravelerInfo: {
        BusinessTravelerType: ''
      },
      Passwords: [{
        NewPassword: '',
        ConfirmPassword: ''
      }]
    },
    SeparateConsent: {
      SeparateConsentCheckbox: ''
    },
    EnrollmentInfo: {},
    HotelPreferences: [{
      PrefType: 'HotelChainPref',
      PrefValue: '',
      PreferLevel: 'Preferred'
    }],
    Preferences: [{
      PreferLevel: 'Unacceptable', // "Preferred" if true
      PrefType: 'EmailOffers'
    },
    {
      PreferValue: 'en-us',
      PrefType: 'CP_LANG_PREF'
    },
    {
      PreferLevel: 'Unacceptable', // "Preferred" if true
      PrefType: 'ThirdPartyEmailOffers'
    }
    ],
    acceptTerms:{ checked: ''},
  },

  validation: {
    'firstName': {
      minLength: 1,
      maxLength: 100,
      nameAndCityValidation: true
    },
    'lastName': {
      minLength: 1,
      maxLength: 100,
      nameAndCityValidation: true
    },
    'emails.0.email': {
      pattern: 'email',
      minLength: 6,
      maxLength: 300
    },
    'addresses.0.countryCode': {
      minLength: 2
    },
    'addresses.0.city': {
      required: (value, attr, computedState) => {
        if (computedState && computedState.addresses && computedState.addresses[0] && computedState.addresses[0].countryCode) {
          return !Utils.countryRequiresZipcode(computedState.addresses[0].countryCode);
        } else {
          const emptyCity = '';
          return emptyCity;
        }
      },
      maxLength: 100,
      nameAndCityValidation: true
    },
    'addresses.0.zip': {
      required: (value, attr, computedState) => {
        if (computedState && computedState.addresses && computedState.addresses[0] && computedState.addresses[0].countryCode) {
          if(ENROLL_PHONE_COUNTRY.includes(computedState.addresses[0].countryCode)) {
            return true;
          }
        } else {
          return false;
        }
      },
      zipCodeValidation: true
    },
    'phones.0.phoneNumber': {
      phoneNumberValidation: true
    },
    'phones.0.typeCode': {
      required: true
    },
    'preferences.BUSTRAVTYPE' :{
      required: (value, attr, computedState) => {
        //Checkbox data-bind
        if (!computedState.preferences.businessEnrollmentCheckbox) {
          computedState.preferences.BUSTRAVTYPE = '';
        }
        return (computedState.preferences.businessEnrollmentCheckbox) ? true : false;
      }
    },
    'SeparateConsent.Pipl' :{
      required: (value, attr, computedState) => {
        //Checkbox data-bind
        return (computedState.SeparateConsent && computedState.SeparateConsent.SeparateConsentCheckbox) ? true : false;
      }
    },
    'Customer.Passwords.0.NewPassword': {
      required: true
    },
    'Customer.Passwords.0.ConfirmPassword': {
      required: true
    },
    'acceptTerms.checked': {
      required: true
    }

  },

  setPromoCode() {
    if (Utils.applicationFlow !== 'ftsi') {
      if (window.enrollmentInfo.PromoCode || getParameterByName('promoCode')) {
        this.set('EnrollmentInfo.PromotionCode', getParameterByName('promoCode') || window.enrollmentInfo.PromoCode);
      }
    }
    if (window.enrollmentInfo.BrandCode || getParameterByName('brandCode')) {
      this.set('HotelPreferences.0.PrefValue', getParameterByName('brandCode') || window.enrollmentInfo.BrandCode);
    }
    if (window.enrollmentInfo.EnrollmentSource || getParameterByName('enrollmentSource')) {
      this.set('EnrollmentInfo.EnrollmentSource', getParameterByName('enrollmentSource') || window.enrollmentInfo.EnrollmentSource);
    }
    if (window.enrollmentInfo.EnrollmentType || getParameterByName('enrollmentType')) {
      this.set('EnrollmentInfo.EnrollmentType', getParameterByName('enrollmentType') || window.enrollmentInfo.EnrollmentType);
    }
    if (window.enrollmentInfo.EnrollmentChannel || getParameterByName('enrollmentChannel')) {
      this.set('EnrollmentInfo.EnrollmentChannel', getParameterByName('enrollmentChannel') || window.enrollmentInfo.EnrollmentChannel);
    }
    if (window.enrollmentInfo.PromotionTrackingCode || getParameterByName('promotionTrackingCode')) {
      this.set('EnrollmentInfo.PromotionTrackingCode', getParameterByName('promotionTrackingCode') || window.enrollmentInfo.PromotionTrackingCode);
    }
    if (window.enrollmentInfo.EnrollerInfo.SiteId || getParameterByName('siteId')) {
      this.set('EnrollmentInfo.EnrollerInfo.SiteId', getParameterByName('siteId') || window.enrollmentInfo.EnrollerInfo.SiteId);
      this.set('EnrollmentInfo.EnrollerInfo.EnrollerNumber',  window.enrollmentInfo.EnrollerInfo.EnrollerNumber);
    }
  },

  save(attrs, options) {
    let payload = _.omit(this.attributes, 'disclaimer');
    options = _.extend({
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(payload)
    }, options);

    this.set('phones.0.phoneNumber', removeNonNumeric(this.attributes.phones[0].phoneNumber));

    return Backbone.DeepModel.prototype.save.call(this, attrs, options);
  },

  enroll(attrs, options, data) {
    options = _.extend({
      type: 'POST',
      contentType: 'application/json',
      dataType: 'json',
      url: requestUrls['enroll'],
      data
    },
    );

    return Backbone.DeepModel.prototype.save.call(this, attrs, options);
  },

  updateProfile(attrs, options) {
    let requestData = _.extend({
      UpdateCustomer: true
    },
    this.pick('Customer')
    );

    let addressLines = [];
    if (requestData.addresses[0].addressLines) {
      requestData.addresses[0].addressLines.forEach((i, e) => {
        if (i.AddressLine.length > 0) {
          addressLines.push(i);
        }
      });
      if (addressLines.length > 0) {
        requestData.addresses[0].addressLines = addressLines;
      } else {
        delete requestData.addresses[0].addressLines;
      }
    }

    if (requestData.addresses[0].stateCode) {
      requestData.addresses[0].stateCode = Form.removeStatePrefix(requestData.addresses[0].stateCode);
    }

    options = _.extend({
      url: requestUrls['updateProfile'],
      data: JSON.stringify(requestData)
    },
    options
    );

    return this.save(attrs, options);
  },

  error(model, xhr, options) {
    Errors.handleResponse(null, xhr, options);
  }
});
